export const getHintFromPaymentStatus = {
  succeeded: 'Patient has completed the payment.',
  incomplete: 'Patient has not yet completed the payment.',
  failed: 'This payment failed. Please, go to payment intent for more details.',
};
